// extracted by mini-css-extract-plugin
export default {"link":"styles-module__link--CTF7m"};